import { footerContent } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-background-200 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10">
            <div>
              <img
                src="/images/logo3.webp"
                alt={footerContent.firmName}
                className="h-8 md:h-10 w-auto object-contain mb-4"
              />
              <p className="text-sm text-foreground-600 leading-relaxed">
                {footerContent.keyword} {footerContent.attorneyName}
              </p>
              <p className="text-sm text-foreground-500 mt-2">
                의뢰인의 아픔에 공감하고 최선을 다하겠습니다.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4 tracking-wide">
                바로가기
              </h4>
              <ul className="space-y-2.5">
                {footerContent.navLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavClick(link.href);
                      }}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4 tracking-wide">
                연락처
              </h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-2.5">
                  <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                    <i className="ri-phone-line" />
                  </span>
                  <a
                    href={`tel:${footerContent.phone}`}
                    className="text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                  >
                    {footerContent.phone}
                  </a>
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="w-4 h-4 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                    <i className="ri-map-pin-line" />
                  </span>
                  <span className="text-sm text-foreground-600 leading-relaxed">
                    {footerContent.address}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              {footerContent.copyright}
            </p>
            <p className="text-xs text-foreground-400">
              {footerContent.keyword} · {footerContent.attorneyName}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}